var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleReady)?_c('product-details',{attrs:{"module-id":_vm.moduleId,"edit-mode":_vm.editMode,"detail-link":_vm.detailLink}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }